import { fdefFormANew } from "./formA_new.js";
import { fdefFormCNew } from "./formC_new.js";
import { fdefFormDNew } from "./formD_new.js";
import { fdefFormENew } from "./formE_new.js";
import { fdefFormFNew } from "./formF_new.js";
import { fdefFormGNew } from "./formG_new.js";
import { fdefFormHNew } from "./formH_new.js";
import { fdefFormINew } from "./formI_new.js";
import { fdefFormSonstigeNew } from "./formSonstige_new.js";
import { fdefFormXNew } from "./formX_new.js";

export const FORM_DEF_MAP = {
  formA_new: fdefFormANew,
  formC_new: fdefFormCNew,
  formD_new: fdefFormDNew,
  formE_new: fdefFormENew,
  formF_new: fdefFormFNew,
  formG_new: fdefFormGNew,
  formH_new: fdefFormHNew,
  formI_new: fdefFormINew,
  formSonstige_new: fdefFormSonstigeNew,
  formX_new: fdefFormXNew,
};

export const DEFAULT_FORM_DEF = fdefFormXNew;
